import Swal from 'sweetalert2';

const show = (icon, html, options = {}) => {
  const { timer = undefined, showConfirmButton = true } = options;
  return Swal.fire({
    icon,
    html,
    allowOutsideClick: false,
    showConfirmButton,
    timer,
  });
};

const toast = {
  warning: (html) => show('warning', html),
  error: (html) => show('error', html),
  success: (html) => show('success', html),
  info: (html) => show('info', html),
  loading: (html = 'Processing...') => {
    Swal.fire({
      title: html,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    // return a handle for compatibility
    return { id: Date.now() };
  },
  update: (_handle, opts = {}) => {
    const { type = 'info', render = '', isLoading = false, autoClose, closeButton = true } = opts;
    if (isLoading) {
      Swal.showLoading();
      return;
    }
    Swal.close();
    const timer = autoClose && autoClose !== true ? autoClose : undefined;
    show(type === 'warning' ? 'warning' : type === 'error' ? 'error' : type === 'success' ? 'success' : 'info', render, {
      timer,
      showConfirmButton: closeButton,
    });
  },
  dismiss: () => Swal.close(),
};

export default toast;

